module.exports = __webpack_public_path__ + "static/media/lib2.20420e23.jpg";